(function(){
	'use strict';

	angular
		.module('app.products')
		.component('isolamentoTermico', isolamentoTermicoComponent());

	function isolamentoTermicoComponent() {
		return {
			template: '',
			bindings: {},
			controller: isolamentoTermicoController,
			controllerAs: 'vm',
			transclude: false,
			templateUrl: 'products/components/isolamento-termico.template.html'
		}
	}

	function isolamentoTermicoController(API) {
		let vm = this;

		vm.textCoberturas = [];
		vm.textAplicacoes = [];
		vm.textVantagens = [];
		vm.textForros = [];

		vm.$onInit = () => {
			_loadFromApi();
		}

		function _loadFromApi() {
			_loadCoberturas();
			_loadAplicacoes();
			_loadVantagens();
			_tiposForros();
		}

		function _loadCoberturas() {
			API.get(`paginas/7`)
			.then(result => vm.textCoberturas = result.data[0])
			.catch(error => {
				console.log(error);
			});
		}

		function _loadAplicacoes() {
			API.get(`paginas/8`)
			.then(result => vm.textAplicacoes = result.data[0])
			.catch(error => {
				console.log(error);
			});
		}

		function _loadVantagens() {
			API.get(`paginas/9`)
			.then(result => vm.textVantagens = result.data[0])
			.catch(error => {
				console.log(error);
			});
		}

		function _tiposForros() {
			API.get(`paginas/10`)
			.then(result => vm.textForros = result.data[0])
			.catch(error => {
				console.log(error);
			});
		}
	}

})();
